// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Pyk1Y","title":"Card_title__EKP0y","separator":"Card_separator__-EpLN","titleContainer":"Card_titleContainer__OMsPd"};